import type { LazyExoticComponent } from "react";
import { lazy } from "react";

export function lazyRetry<T extends React.ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
  retries = 3,
  delay = 500
): LazyExoticComponent<T> {
  const load = (): Promise<{ default: T }> => {
    let attempts = 0; // number of retries already done

    const attemptLoad = (): Promise<{ default: T }> =>
      factory().catch(err => {
        if (attempts >= retries) {
          // exhausted retry attempts -> rethrow
          throw err;
        }
        attempts += 1;
        return new Promise<{ default: T }>(resolve => setTimeout(() => resolve(attemptLoad()), delay));
      });

    return attemptLoad();
  };

  return lazy(load);
}
